/* eslint no-useless-constructor: "off" */

import * as Api from 'api';

class BaseApiSetting {
  constructor (token) {
    const defaultClient = Api.ApiClient.instance;
    defaultClient.basePath = process.env.VUE_APP_HST_API_URL;
    const Authorization = defaultClient.authentications['Authorization'];
    Authorization.apiKey = token;
    this.version = process.env.VUE_APP_HST_API_VERSION;
  }
}

class Bike extends BaseApiSetting {
  constructor (token) {
    super(token);
  }
  async createBike ({ vin, parts, spec_id: specId }) {
    let body = new Api.CreateBikeRequest();
    body.vin = vin;
    body.parts = parts;
    body.spec_id = specId;

    const result = await new Api.BikeApi().createBike(body);
    return result;
  }
  async createBikeForQwic ({ vin, parts, spec_id: specId }) {
    let body = new Api.CreateBikeRequest();
    body.vin = vin;
    body.parts = parts;
    body.spec_id = specId;

    const result = await new Api.QwicBikeApi().createQwicBike(body);
    return result;
  }
  async getBikeIdByMid (mid) {
    let bikeBundle = await new Api.BikeBundleApi().queryBikeBundle({
      'mid': mid
    });
    return (bikeBundle.result.length > 0) ? bikeBundle.result[0].bike_id : '';
  }
  async getBikeBundleByBikeId (bikeId) {
    let bikeBundle = await new Api.BikeBundleApi().queryBikeBundle({
      'bikeId': bikeId
    });
    return bikeBundle.result;
  }
  async getBikeInfo (bikeId) {
    let bikeInfo = await new Api.BikeApi().getBike(bikeId);
    return bikeInfo.result;
  }
  async getQwicBikeModel (vin) {
    const result = await new Api.QwicBikeApi().getQwicBikeModel(vin);
    return result;
  }
  async compareQwicBike ({ vin, parts, spec_id: specId }) {
    let body = new Api.CompareBikeRequest();
    body.vin = vin;
    body.parts = parts;
    const result = await new Api.QwicBikeApi().compareQwicBike(body);
    return result;
  }
}

class Part extends BaseApiSetting {
  constructor (token) {
    super(token);
  }
  async getPart (mid) {
    const result = await new Api.PartApi().getPart(mid);
    return result;
  }
  async createPartOutsource ({ id, partNum, barcode, fwVer }) {
    let body = new Api.PartOutsourceRequest();
    body.id = id;
    body.part_num = partNum;
    body.barcode = barcode;
    body.fw_ver = fwVer;
    console.log('body', body);

    const result = await new Api.PartApi().createPartOutsource(body);
    return result;
  }
  async createPart ({ partNum, barcode, fwVer }) {
    let body = new Api.PartRequest();
    body.part_num = partNum;
    body.barcode = barcode;
    body.fw_ver = fwVer;
    const result = await new Api.PartApi().createPart(body);
    return result;
  }
}

class Firmware extends BaseApiSetting {
  constructor (token) {
    super(token);
  }
  async getFirmwareUrl (firmwareId) {
    const result = await new Api.FirmwareApi().getFirmwareFile(firmwareId);
    return result;
  }
  async queryFirmwareList (partNum) {
    const result = await new Api.FirmwareApi().queryFirmwareList(partNum);
    return result;
  }
}

class PartSpec extends BaseApiSetting {
  constructor (token) {
    super(token);
  }
  async getPartSpec (specId) {
    const result = await new Api.PartSpecApi().getPartSpec(specId);
    return result;
  }
}

class Customer extends BaseApiSetting {
  constructor (token) {
    super(token);
  }
  async getCustomer (customerId) {
    const result = await new Api.CustomerApi().getCustomer(customerId);
    return result;
  }
}

class MessageGateway extends BaseApiSetting {
  constructor (token) {
    super(token);
  }
  async getLatestVersion () {
    const result = await new Api.MessageGatewayApi().getMessageGateway();
    return result;
  }
}

export { Bike, Part, Firmware, PartSpec, Customer, MessageGateway };
